<template>
  <div class="xubio-salaries">
    <div class="columns is-gapless">
      <div class="column is-4">
        <div class="info-column">
          <a href="https://xubio.com/" target="_blank">
            <h4 class="client">Xubio LLC</h4>
          </a>
          <h1 class="title">
            {{ $t("salaries.title") }}
          </h1>
          <p class="date">
            {{ $t("salaries.duration.title") }}
            {{ $t("salaries.duration.date") }}
          </p>
          <p class="role">
            {{ $t("salaries.position.title") }}
            {{ $t("salaries.position.role") }}
          </p>
          <p class="description">
            {{ $t("salaries.description") }}
          </p>
        </div>
      </div>
      <div class="column is-8">
        <div class="multimedia-container">
          <!-- <img src="@/assets/formulasdemo.gif" alt="" class="demo"> -->
          <video autoplay loop muted ref="video" :controls="isMobile">
            <source src="@/assets/formulasdemo.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";

export default {
  name: "XubioSalaries",
  components: {},
  data() {
    return {
      isMobile: isMobile,
    };
  },
  mounted() {
    this.$refs.video.play();
  },
};
</script>
<style lang="scss" scoped>
div.xubio-salaries {
  background-color: #16627e;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5rem 0;

  @media (min-width: 600px) {
    padding: 0;
    height: 100vh;
  }

  div.info-column {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 2rem;
    font-family: "Raleway";

    h4.client {
      align-self: flex-start;
      font-size: 0.8rem;
      color: rgba(#fff, 0.3);
      font-weight: bold;
      // font-family: "Raleway";
    }

    h1.title {
      color: #fff;
      font-family: "Raleway";
    }

    p.description {
      text-align: left;
      margin-top: 1.5rem;
    }

    p.date,
    p.role {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      color: #cccccc;
      font-size: 1.2rem;
    }
  }

  div.multimedia-container {
    img,
    video {
      box-shadow: 3px 3px 38px 7px #000;
      max-width: 100vw;
    }
  }
}
</style>
